angular.module('leanlaw').controller('TrustRequestCtrl', ['$scope', '$q', '$http', '$state', '$stateParams', 'alerts', 'userService', 'leanLawAuth', 'leanLawApi', 'matterManager', 'clientManager', 'utils', function ($scope, $q, $http, $state, $stateParams, alerts, userService, leanLawAuth, leanLawApi, matterManager, clientManager, utils) {
  $scope.vm = {
    cc: undefined
  };
  $scope.accounts = [];
  $scope.me = {};
  $scope.date = new Date();
  $scope.amount = $stateParams.amount || '';
  $scope.invoiceDeliverySettings = {};
  $scope.body = '';
  $scope.subject = '';
  $scope.invoiceDeliverySettingsLoaded = false;
  $scope.multipleEmailPattern = utils.emailRegexPattern;
  $scope.gravityLoading = true;
  $scope.gravityValid = false; // Default to false
  $scope.loading = false; // Default to false
  $scope.saving = false; // Default to false
  $scope.pick = false;
  $scope.description = "";
  $scope.additionalEmailsCount = 0;
  $scope.cm = {
    client: null,
    matter: null
  };
  // Query object consumed by the <ll-client-matter-search> directive. This modal is
  // reached from Trust Accounts pages, so surface secondary split matters (matches the
  // prior matterManager.list({ showSecondarySplitMatter: true }) load below).
  $scope.cmQuery = {
    originating: false,
    involved: false,
    reviewer: false,
    primary: false,
    scopeAccount: null,
    archived: false,
    showSecondarySplitMatter: true
  };
  activate();
  $scope.save = save;
  $scope.resetValues = resetValues;
  $scope.cancel = function () {
    $state.go('^');
  };
  $scope.firstDeposit = function () {
    if (!$scope.cm.client) {
      return false;
    }
    // Optional chaining throughout: ng-show re-evaluates this every digest, including while the
    // client/matter search directive still holds a lean option object with no .billing.
    if ($scope.cm.client.billing?.billClient) {
      return !$scope.cm.client.billing.trust;
    }
    return !!$scope.cm.matter && !$scope.cm.matter.billing?.trust;
  };

  // Whether to offer the trust account picker. Client-anchored on purpose: the client owns the trust
  // slot, because a matter's liability account is created *under* the client's, and
  // PrepareTrustAccount takes the matter's slot from the client rather than from what's picked here.
  // Offering the choice for a matter whose client is already attached would silently discard it.
  // Requiring .billing (not just the client) also waits out the lean option object the search
  // directive assigns, so the field doesn't flash in before enrichClient() can reveal an existing
  // trust account. setDefaultClientBilling() guarantees a full record always has .billing.
  $scope.showTrustAccount = function () {
    return $scope.trusts && $scope.trusts.length > 1 && !!$scope.cm.client?.billing && !$scope.cm.client.billing.trust;
  };

  // Keep the picked trust account in step with the selected client/matter (mirrors TrustDeposit's
  // updateTrustAccount). Without this the firm default seeded in activate() sticks regardless of who
  // is selected, so the submitted trust could disagree with a record already on another slot.
  function updateTrustAccount() {
    if (!$scope.trusts) return;
    const {
      client,
      matter
    } = $scope.cm;
    const existing = client?.billing?.billClient ? client.billing.trust : matter?.billing?.trust;
    if (existing) {
      // Already attached -- the slot is settled, so reflect it rather than the seeded default.
      $scope.trust = $scope.trusts.find(t => t.id === existing.id) || $scope.trust;
    } else if (!$stateParams.trustId) {
      // Not attached, and we weren't opened from a specific trust account page whose selection
      // we'd be clobbering.
      $scope.trust = $scope.trusts.find(t => t.defaultAccount);
    }
  }

  // The <ll-client-matter-search> directive handles client/matter selection and the
  // client -> matter cascade internally, but it only emits lean option objects (id/label,
  // no billing/contact/primary). This modal reads those fields off cm.client/cm.matter, so
  // whenever the directive changes the selection we swap the lean object for the full record
  // (from the already-loaded $scope.clients/$scope.matters, falling back to a direct fetch).
  function isFullClient(client) {
    return !!(client && client.billing);
  }
  function isFullMatter(matter) {
    return !!(matter && matter.client);
  }
  function enrichClient(client) {
    if (!client || isFullClient(client)) {
      return $q.resolve(true);
    }
    const found = ($scope.clients || []).find(c => c.id === client.id);
    if (found) {
      $scope.cm.client = found;
      return $q.resolve(true);
    }
    return clientManager.get(client.id).then(full => {
      $scope.cm.client = full;
      return true;
    }).catch(() => {
      alerts.error('Unable to load the selected client. Please try again.');
      return false;
    });
  }
  function enrichMatter(matter) {
    if (!matter || isFullMatter(matter)) {
      return $q.resolve(true);
    }
    const found = ($scope.matters || []).find(m => m.id === matter.id);
    if (found) {
      $scope.cm.matter = found;
      return $q.resolve(true);
    }
    return matterManager.get(matter.id).then(full => {
      $scope.cm.matter = full;
      return true;
    }).catch(() => {
      alerts.error(`Unable to load the selected ${$scope.me.terms?.matter || 'matter'}. Please try again.`);
      return false;
    });
  }
  $scope.$watch('cm.client', function (newVal, oldVal) {
    if (!newVal) {
      if (oldVal) {
        setEmail();
      }
      return;
    }
    // Already the full record and nothing new selected -> nothing to do.
    if (isFullClient(newVal) && newVal.id === (oldVal && oldVal.id)) {
      return;
    }
    enrichClient(newVal).then(function (ok) {
      if (!ok) {
        return;
      }
      setDefaultClientBilling();
      updateTrustAccount();
      setEmail();
      resetValues();
    });
  });
  $scope.$watch('cm.matter', function (newVal, oldVal) {
    if (newVal && isFullMatter(newVal) && newVal.id === (oldVal && oldVal.id)) {
      return;
    }
    enrichMatter(newVal).then(function (ok) {
      if (!ok) {
        return;
      }
      if ($scope.cm.client) {
        setDefaultClientBilling();
      }
      updateTrustAccount();
      setEmail();
      resetValues();
    });
  });
  function setEmail() {
    $scope.email = '';
    $scope.vm.cc = $scope.me.company.settings.emailCc;
    const {
      client,
      matter
    } = $scope.cm;
    if (!client) return;
    $scope.email = client.contact.email;
    $scope.vm.cc = client.contact.cc || $scope.vm.cc;
    if (matter && matter.contact) {
      $scope.email = matter.contact.email;
      $scope.vm.cc = matter.contact.cc || $scope.vm.cc;
    }
  }
  function setDefaultClientBilling() {
    if (!$scope.cm.client.accounting) {
      // set default for billClient so that downstream logic can create things correctly
      $scope.cm.client.billing = $scope.cm.client.billing || {};
      if (typeof $scope.cm.client.billing.billClient === "undefined") {
        $scope.cm.client.billing.billClient = $scope.me.company.settings.clientBilling.billClient;
      }
      if ($scope.cm.client.billing.billClient) {
        $scope.cm.matter = null;
      }
    }
  }

  //////////////////

  function activate() {
    // messy: we might have a client or matter from the parent scope and if not we will have a clientMatter picker
    $scope.cm.matter = $scope.clientMatter ? $scope.clientMatter.matter : $scope.matter;
    $scope.cm.client = $scope.clientMatter ? $scope.clientMatter.client : $scope.client;
    if (!$scope.cm.client || !$scope.cm.matter && $scope.cm.client.billing.billClient) {
      $scope.pick = true;
    }
    userService.me().then(me => {
      $scope.me = me;
      getInvoiceDeliverySettings();
      checkGravitySetup();
      $scope.trusts = me.company.settings.trust.accounts;
      $scope.trust = $scope.trusts.find(t => $stateParams.trustId ? t.id === $stateParams.trustId : t.defaultAccount);
      if (!$scope.trust && me.company.settings.trust) {
        $scope.trust = $scope.trusts.find(t => t.defaultAccount);
      }
      // The cm watchers can fire before this resolves, in which case they bailed on the missing
      // trusts list -- sync once here for the client/matter we were opened with.
      updateTrustAccount();
      if (me.company.settings.emailCc) {
        $scope.vm.cc = me.company.settings.emailCc;
      }
    });
    matterManager.list({
      scope: 'all',
      showSecondarySplitMatter: true
    }).then(matters => {
      $scope.matters = _.sortBy(matters, m => m.label);
      matterManager.listClientsFromMatters(matters).then(clients => {
        $scope.clients = _.sortBy(clients, c => c.label);
        if ($scope.cm.client) {
          $scope.cm.client = $scope.clients.find(c => c.id === $scope.cm.client.id);
        }
        setEmail();
      });
    });
  }
  function checkGravitySetup() {
    $http.get(`${leanLawAuth.domain}/v1/me/company/validate`).then(result => {
      var gravity = result.data.gravity;
      $scope.gravityValid = gravity.customer && gravity.validToken && (gravity.achProcessing || gravity.ccProcessing);
      $scope.gravityLoading = false;
    });
  }
  function getInvoiceDeliverySettings() {
    $http.get(`${leanLawAuth.domain}/v1/invoicedeliverysettings?messagetype=4`).then(result => {
      if (result.data.enabled) {
        $scope.invoiceDeliverySettings = result.data;
        $scope.invoiceDeliverySettingsLoaded = true;
        if ($scope.client || $scope.cm.matter?.client) {
          resetValues();
        }
      } else {
        $scope.invoiceDeliverySettings = {
          enabled: false,
          trustRequestSubject: 'Trust Request',
          trustRequestBody: `You have a new trust request from ${$scope.me.company.name}.\nAmount due: {trust_amount_due}`
        };
        $scope.invoiceDeliverySettingsLoaded = true;
        $scope.replyTo = $scope.me.email;
        if ($scope.client || $scope.cm.matter?.client) {
          resetValues();
        }
      }
    });
  }
  function resetValues() {
    if ($scope.invoiceDeliverySettingsLoaded) {
      $scope.emailMessage = injectTemplateValues($scope.invoiceDeliverySettings.trustRequestBody);
      $scope.subject = injectTemplateValues($scope.invoiceDeliverySettings.trustRequestSubject);
    } else {
      getInvoiceDeliverySettings();
    }
  }
  function injectTemplateValues(original) {
    // Invoice delivery can be enabled without a trust-request template configured, in which
    // case the backend returns a null subject/body. Nothing to interpolate in that case.
    if (!original) {
      return original || '';
    }
    let responsiblesString = '';
    if ($scope.cm.client && original.indexOf("{responsible}") > -1) {
      let matters = [];
      if ($scope.cm.matter) {
        matters.push($scope.cm.matter);
      } else {
        matters = $scope.matters.filter(m => m.client.id === $scope.cm.client.id);
      }
      const responsibles = matters?.map(m => m.primary.name) || "";
      responsiblesString = responsibles.length > 1 ? responsibles.join(', ') : responsibles[0] || "";
    }
    var client = $scope.cm.client || $scope.clients.find(x => x.id === $scope.cm.matter.client.id);
    var matter = $scope.cm.matter || {
      name: ""
    };
    return original.replace("{client_name}", client?.name || "{client_name}").replace("{client_first_name}", client?.contact.first || "{client_first_name}").replace("{client_last_name}", client?.contact.last || "{client_last_name}").replace("{trust_amount_due}", ($scope.amount || 0).toLocaleString("en-US", {
      style: "currency",
      currency: "USD"
    })).replace("{responsible}", responsiblesString).replace("{matter_name}", matter.name);
  }
  function connect(accounting, item, state) {
    if (accounting.connect) {
      state.message = `To setup trust accounting, the ${item} must be associated with a QuickBooks customer`;
      state.onCancel = function () {
        $scope.message = `The ${item} must be connected to a QuickBooks customer`;
      };
      $state.go('.connect', state);
    }
  }
  function ensureConnected() {
    const {
      billClient
    } = $scope.cm.client.billing;
    if ((!$scope.cm.matter || $scope.cm.matter.accounting || billClient) && $scope.cm.client.accounting) {
      return $q.resolve();
    }

    // The client/matter is not connected to QuickBooks correctly, sort it out
    if ($scope.cm.matter) {
      return matterManager.get($scope.cm.matter.id).then(matter => matter.getOrConnectAccounting().then(accounting => {
        connect(accounting, $scope.me.terms.matter, {
          matterId: matter.id
        });
      }));
    }
    return clientManager.get($scope.cm.client.id).then(client => client.getOrConnectAccounting().then(accounting => {
      connect(accounting, "client", {
        clientId: client.id
      });
    }));
  }
  $scope.validateSingleEmail = function () {
    $scope.additionalEmailsCount = 0;
    if (!$scope.email) return;

    // Split the string by space and comma, filter out empty strings
    const emails = $scope.email.split(/[\s,]+/).filter(Boolean);
    if (emails.length > 1) {
      // Filter out invalid emails and only count valid ones
      const validEmails = emails.filter(email => utils.isValidSingleEmail(email.trim()));
      if (validEmails.length > 1) {
        // More than one valid email found, update the count
        $scope.additionalEmailsCount = validEmails.length - 1;
        return true;
      }
    }

    // For single email (or if no valid multiple emails), validate the format
    return !utils.isValidSingleEmail($scope.email.trim());
  }; // Initialize CC validation state      // Simple validation function that uses the existing utils.isValidEmail
  $scope.isCcEmailValid = function () {
    // Ensure vm object exists
    if (!$scope.vm || !$scope.vm.cc || $scope.vm.cc.trim() === '') {
      return true; // Empty CC email is valid
    }
    // Safety check - ensure utils service is available
    if (!utils || !utils.isValidEmail) {
      console.warn('utils.isValidEmail is not available');
      return true; // Default to valid if utils not available
    }
    // Use the existing utils.isValidEmail which supports multiple emails
    const isValid = utils.isValidEmail($scope.vm.cc);
    return isValid;
  }; // Function to trigger CC email validation (called from ng-change)
  $scope.validateCcEmail = function () {
    // Force digest cycle to update UI
    if (!$scope.$$phase) {
      $scope.$apply();
    }
  }; // Debug function to check button disabled state
  $scope.isButtonDisabled = function () {
    // Ensure all variables have default values to avoid undefined
    const loading = !!$scope.loading;
    const saving = !!$scope.saving;
    const gravityValid = !!$scope.gravityValid;
    const hasCc = !!($scope.vm && $scope.vm.cc);
    const ccValid = hasCc ? $scope.isCcEmailValid() : true;
    const disabled = loading || saving || !gravityValid || hasCc && !ccValid;
    return disabled;
  };
  function save() {
    if (!($scope.amount > 0) || !$scope.date) {
      alerts.error("An amount is required to make a request");
      return;
    }
    if (!$scope.cm.client) {
      alerts.error("You have to select a client to make a request");
      return;
    }

    // The select is deselectable and this choice is permanent -- it's what attaches the client to a
    // trust account going forward -- so don't fall through to the firm default.
    if ($scope.showTrustAccount() && !$scope.trust) {
      alerts.error("You have to select a trust account for this request");
      return;
    }
    if (!$scope.email) {
      alerts.error("An email address is required");
      return;
    }
    if (!$scope.subject) {
      alerts.error("An email subject is required");
      return;
    }
    if (!$scope.emailMessage) {
      alerts.error("An email message is required");
      return;
    }
    if (!$scope.invoiceDeliverySettings.enabled && !$scope.replyTo) {
      alerts.error("A ReplyTo email address is required");
      return;
    }
    // Validate CC email addresses before saving
    if ($scope.vm.cc && !utils.isValidEmail($scope.vm.cc)) {
      alerts.error("Invalid email address in the CC field");
      return;
    }
    $scope.saving = true;
    return ensureConnected().then(() => {
      const {
        billClient
      } = $scope.cm.client.billing;
      if (!$scope.cm.matter && !billClient) {
        alerts.error(`You have to select a ${$scope.me.terms.matter} to make a trust request`);
        return;
      }
      const payload = {
        clientId: $scope.cm.client.id,
        matterId: $scope.cm.matter?.id,
        amount: $scope.amount,
        trust: $scope.trust,
        depositMemo: $scope.memo || "Trust Request",
        replyTo: $scope.replyTo,
        to: $scope.email,
        ccs: $scope.vm.cc,
        subject: $scope.subject,
        body: $scope.emailMessage
      };
      $scope.saving = true;
      return $http.post(`${leanLawAuth.domain}/v1/trustrequest`, payload).then(result => {
        if (result.status === 200) {
          alerts.success("The trust request was made. The client will receive an email with payment instructions.");
          $state.go('^', {}, {
            reload: true
          });
        } else {
          alerts.error(result.data.message);
        }
      });
    }).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.saving = false;
    });
  }
}]);